/**
 * @fileoverview GET handler for the "/companies/:company_id/app_group_permission_sets/all_permission_sets" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { companiesCompanyIdAppGroupPermissionSetsAllPermissionSets } from "./constants";
import type { CompaniesCompanyIdAppGroupPermissionSetsAllPermissionSetsResult } from "./types";

export const getCompaniesCompanyIdAppGroupPermissionSetsAllPermissionSets = reactQueryFetcherAdapter(
  companiesCompanyIdAppGroupPermissionSetsAllPermissionSets,
  (
    signal: AbortSignal,
    companyId: string
  ): Promise<CompaniesCompanyIdAppGroupPermissionSetsAllPermissionSetsResult> => {
    return fetch(
      `/companies/${encodeURIComponent(companyId)}/app_group_permission_sets/all_permission_sets`,
      "GET",
      {},
      { signal }
    );
  }
);
